import React from 'react';
import {useTranslation} from "react-i18next";
import {Flex} from "antd";
import {Commentary} from "../../../api/types";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import IconComment from "../../ui/icons/IconComment";
import {plural} from "../../../utils";
import IconRightArrow from "../../ui/icons/IconRightArrow";
import IconLeftArrow from "../../ui/icons/IconLeftArrow";
import {RollbackOutlined} from "@ant-design/icons";

dayjs.extend(utc)

interface CommentProps {
  commentary: Commentary,
  isCommentExpanded: Function,
  toggleComment: Function,
  setSelectedComment: Function,
}

export default function Comment({commentary, toggleComment, isCommentExpanded, setSelectedComment}: CommentProps) {
  const {t} = useTranslation()

  const getTime = (date: string) => {
    const originalTimezone = date.slice(-6);
    const format = (commentary.level && commentary.level > 2) ? 'HH:mm DD.MM.YYYY' : 'HH:mm'
    return dayjs(date).utcOffset(originalTimezone).format(format);
  }

  return (
    <Flex gap={'small'} className={'commentary__item'} vertical align={'flex-start'}>
      <Flex gap={4} align={'center'}>
        <div
          className={'commentary__item--author'}>{commentary.author ? ((commentary.author.fName + ' ' + commentary.author.lName) || commentary.author.email) : ''}</div>
        <div className={'commentary__item--position'}>{commentary.author ? commentary.author.position : ''}</div>
        <div className={'commentary__item--time'}>{getTime(commentary.createdAt || '')}</div>
        <div className={'commentary__item--reply-button'}
             onClick={(event) => {
               event.stopPropagation()
               setSelectedComment(commentary)
             }}
             title={t('common.reply')}
        >
          <RollbackOutlined/>
        </div>
      </Flex>
      <div className={'commentary__item--text'}>{commentary.text}</div>
      {commentary.countChildren > 0 &&
        <>
          <div className={'commentary__item--children'}
               onClick={(event) => {
                 event.stopPropagation()
                 toggleComment(commentary)
               }}>
            <IconComment/>
            <div className={'commentary__item--children-count'}>{plural(commentary.countChildren,
              [t('edit.comment').toLowerCase(), t('edit.comments2').toLowerCase(), t('edit.comments5').toLowerCase()])}</div>
            {isCommentExpanded(commentary.id)
              ? <IconLeftArrow/>
              : <IconRightArrow/>
            }
          </div>

          {isCommentExpanded(commentary.id) &&
            <div className={'commentary__item--children-items'}>
              {commentary.children.map(childCommentary => (
                <Comment
                  key={childCommentary.id}
                  commentary={childCommentary}
                  isCommentExpanded={isCommentExpanded}
                  toggleComment={toggleComment}
                  setSelectedComment={setSelectedComment}
                />
              ))}
            </div>
          }
        </>
      }
    </Flex>
  )
}
